// Redirects to /textos-liberados only if every user role is in this list (any subset qualifies)
const TEXT_RELEASE_HOME_ALLOWED_ROLES = [
  "AttachmentViewer",
  "Channel",
  "TextRelease",
];

const isOnly = (list, value) => list?.length === 1 && list[0] === value;

export function getHomeRoute({ permissions, roles }) {
  if (!permissions?.length) return "/acesso-negado";

  // Users with another active role besides CultureHub keep their normal home route on "/";
  // the CultureHub redirect for them only happens once, right after login (see Auth.js)
  if (isOnly(roles, "CultureHub")) return "/hub-cultura";

  if (
    isOnly(roles, "AttachmentViewer") &&
    isOnly(permissions, "AttachmentViewer")
  )
    return "/textos-compartilhados";

  if (
    roles?.includes("ExternalProject") &&
    permissions.includes("ExternalProject")
  )
    return "/projetos-externos";

  if (roles?.every((role) => TEXT_RELEASE_HOME_ALLOWED_ROLES.includes(role)))
    return "/textos-liberados";

  return "/";
}
